var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4167 3.75H5.58333C4.3682 3.75146 3.20326 4.23481 2.34403 5.09403C1.48481 5.95326 1.00146 7.1182 1 8.33333H23C22.9985 7.1182 22.5152 5.95326 21.656 5.09403C20.7967 4.23481 19.6318 3.75146 18.4167 3.75Z",
    fill: "#382E6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.6667C1.00146 16.8818 1.48481 18.0467 2.34403 18.906C3.20326 19.7652 4.3682 20.2485 5.58333 20.25H18.4167C19.6318 20.2485 20.7967 19.7652 21.656 18.906C22.5152 18.0467 22.9985 16.8818 23 15.6667V10.1667H1V15.6667ZM7.41667 15.2083C7.41667 15.4803 7.33602 15.7461 7.18494 15.9722C7.03385 16.1984 6.81911 16.3746 6.56786 16.4787C6.31661 16.5827 6.04014 16.61 5.77342 16.5569C5.50669 16.5039 5.26169 16.3729 5.06939 16.1806C4.8771 15.9883 4.74614 15.7433 4.69309 15.4766C4.64003 15.2099 4.66726 14.9334 4.77133 14.6821C4.8754 14.4309 5.05164 14.2162 5.27776 14.0651C5.50388 13.914 5.76972 13.8333 6.04167 13.8333C6.40634 13.8333 6.75608 13.9782 7.01394 14.2361C7.2718 14.4939 7.41667 14.8437 7.41667 15.2083Z",
    fill: "#382E6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentManagement);
export default __webpack_public_path__ + "static/media/payment-management.30f535155323b3cf7193590ab3ccbd3a.svg";
export { ForwardRef as ReactComponent };